import { ESdChangeReason, EWFDueUnit, IWFDue } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import "./workflow-due.scss";
import KuikaInput from "../../../../ui-kit/kuika-input/kuika-input";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../../ui-kit/kuika-selectbox/kuika-selectbox";

export interface IWorkflowDueState {}

export interface IWorkflowDueProps {
  due: IWFDue | undefined;
  onDueUnitChange: (dueUnit) => void;
  onDueValueChange: (dueValue) => void;
  loading: boolean;
  id: string;
}

class WorkflowDue extends PureSdComponent<IWorkflowDueProps & IWithSDProps & IWithContextProp, IWorkflowDueState> {
  constructor(props: IWorkflowDueProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  getDueValue = () => {
    if (this.props.due) {
      return this.props.due.dueValue;
    }
    return 1;
  };

  setDueValue = (e) => {
    if (e.target.value > 0) {
      this.props.onDueValueChange(e.target.value);
    }
  };

  getSelectedDueUnit = () => {
    if (this.props.due) {
      return this.props.due.dueUnit;
    }
    return EWFDueUnit.Days;
  };

  setSelectedDueUnit = (e) => {
    this.props.onDueUnitChange(e);
  };

  render() {
    const dueValue = _.clone(this.getDueValue());
    return (
      <div id={this.props.id}>
        <div className="kuika-wf-due__row">
          {/* Uncontrolled: the count saves on blur, and this field re-renders on every broadcast, so a
              caller-held value would snap each keystroke back to the saved count. The key remounts it
              when the saved count changes from outside (undo, another step selected). */}
          <KuikaInput
            key={String(dueValue)}
            data-testid="processDueNumberInput"
            className="kuika-wf-due__count"
            size="sm"
            type="number"
            precision={0}
            defaultValue={dueValue}
            onBlur={(e) => this.setDueValue(e)}
            disabled={this.props.loading}
            min={1}
            id={`${this.props.id}-input`}
          />
          <KuikaSelectbox
            data-testid="processDueSelectTimeDropdown"
            searchable
            size="sm"
            className="kuika-wf-due__unit"
            value={this.getSelectedDueUnit()}
            onChange={(val: EWFDueUnit) => this.setSelectedDueUnit(val)}
            key={this.getSelectedDueUnit()}
            disabled={this.props.loading}
            options={DUE_UNIT_OPTIONS}
          />
        </div>
      </div>
    );
  }

  checkNeedRender = (_changeReason: ESdChangeReason): boolean => {
    return true;
  };
}

const DUE_UNIT_OPTIONS: KuikaSelectboxOption[] = [
  { value: EWFDueUnit.Days, label: "Days", testId: "daysOption" },
  { value: EWFDueUnit.Hours, label: "Hours", testId: "hoursOption" },
  { value: EWFDueUnit.Minutes, label: "Minutes", testId: "minutesOption" }
];

const workflowDue = withContext<IWorkflowDueProps>(withSD<IWorkflowDueProps>(WorkflowDue));
export { workflowDue as WorkflowDue };
